import {
  GetTelemetryHistoryResponse,
  GetTelemetryHistoryParam,
  GetTelemetryHistoryQuery,
} from '@eppendorf/vnls-device-service-utils';
import { keepPreviousData, useQuery } from '@tanstack/react-query';

import { fetcher } from '$shared/fetch';
import {
  createPathWithQueryParams,
  DEVICE_SERVICE_BASE_PATH,
  objectToURLSearchParams,
} from '$shared/utils/api-paths';

export const historyChartsQueryKey = 'history-charts-v2';

export const createHistoryChartsQueryWithQueryParams = (
  param: GetTelemetryHistoryParam,
  query: GetTelemetryHistoryQuery,
) => ({
  queryKey: [
    historyChartsQueryKey,
    ...objectToURLSearchParams(query).values(),
    ...objectToURLSearchParams(param).values(),
  ],
  queryFn: async () => {
    const response = await fetcher.get<GetTelemetryHistoryResponse>(
      createPathWithQueryParams(
        `${DEVICE_SERVICE_BASE_PATH}/${param.deviceId}/history`,
        query,
      ),
    );

    return response;
  },
  placeholderData: keepPreviousData,
});

export const useDeviceHistoryChart = (
  param: GetTelemetryHistoryParam,
  query: GetTelemetryHistoryQuery,
) =>
  useQuery({
    ...createHistoryChartsQueryWithQueryParams(param, query),
    refetchInterval: false,
    staleTime: Infinity,
    enabled:
      Boolean(param.deviceId) &&
      Boolean(query.startDate) &&
      Boolean(query.endDate) &&
      Boolean(query.telemetryId),
    refetchOnMount: false,
  });
